/* URUZEN — carrito.js (drawer de carrito con upsells) */
(function () {
  var drawer = document.getElementById('CarritoDrawer');
  var overlay = document.getElementById('DrawerOverlay');
  if (!drawer || !overlay) return;

  var FORMATO = drawer.getAttribute('data-money-format') || '$ {{amount_no_decimals_with_comma_separator}}';
  var UMBRAL = parseInt(drawer.getAttribute('data-umbral') || '0', 10);
  var PROT = drawer.getAttribute('data-proteccion') || '';
  var ultimoCarrito = null;

  function money(cents) {
    var m = FORMATO.match(/\{\{\s*(\w+)\s*\}\}/);
    var tipo = m ? m[1] : 'amount';
    function sep(precision, miles, decimal) {
      var partes = (cents / 100).toFixed(precision).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return partes.join(decimal);
    }
    var v;
    if (tipo === 'amount_no_decimals') v = sep(0, ',', '.');
    else if (tipo === 'amount_with_comma_separator') v = sep(2, '.', ',');
    else if (tipo === 'amount_no_decimals_with_comma_separator') v = sep(0, '.', ',');
    else v = sep(2, ',', '.');
    return FORMATO.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img160(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function abrir() {
    drawer.classList.add('drawer--abierto');
    overlay.classList.add('drawer-overlay--visible');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-bloqueado');
  }
  function cerrar() {
    drawer.classList.remove('drawer--abierto');
    overlay.classList.remove('drawer-overlay--visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-bloqueado');
  }

  function pintar(cart) {
    if (!cart || !cart.items) { return refrescar(false); }
    ultimoCarrito = cart;
    var visibles = cart.items.filter(function (it) { return String(it.variant_id) !== PROT; });

    /* Collect cart-level discount info to show per item */
    var cartDescuentos = (cart.cart_level_discount_applications || []);
    /* Map discount allocated per line from discount_allocations or total_discount */
    var html = visibles.map(function (it) {
      var lineDiscount = it.total_discount || 0;
      var promos = (it.discount_allocations || it.line_level_discount_allocations || []).map(function (d) {
        return '<div class="car-item__promo">' + esc(d.discount_application.title) + ' −' + money(d.amount) + '</div>';
      }).join('');
      /* If no line-level promos but item has _bundle and cart has discounts, show cart discount on this item */
      var bundlePromo = '';
      if (it.properties && it.properties._bundle) {
        var descMonto = lineDiscount > 0 ? lineDiscount : (it.original_line_price > it.final_line_price ? it.original_line_price - it.final_line_price : 0);
        /* Fallback: if still 0 and cart has discounts, distribute cart discount proportionally */
        if (descMonto === 0 && cart.total_discount > 0) {
          var totalOriginal = visibles.reduce(function(s, v) { return s + v.original_line_price; }, 0);
          descMonto = totalOriginal > 0 ? Math.round(cart.total_discount * (it.original_line_price / totalOriginal)) : cart.total_discount;
        }
        bundlePromo = '<div class="car-item__promo">' + esc(it.properties._bundle) + (descMonto > 0 ? ' −' + money(descMonto) : '') + '</div>';
      }
      /* Show original price crossed out if there's any discount */
      var hayDescuento = it.original_line_price > it.final_line_price || lineDiscount > 0 || (it.properties && it.properties._bundle && cart.total_discount > 0);
      var precioOriginal = it.original_line_price || (it.original_price * it.quantity);
      var precioFinal = it.final_line_price;
      /* For cart-level discounts, final_line_price may not reflect discount; compute real final */
      if (lineDiscount > 0 && it.original_line_price === it.final_line_price) {
        precioFinal = it.original_line_price - lineDiscount;
      }
      return (
        '<div class="car-item">' +
          (it.image
            ? '<img class="car-item__img" src="' + esc(img160(it.image)) + '" alt="" loading="lazy">'
            : '<div class="car-item__img"></div>') +
          '<div class="car-item__info">' +
            '<a class="car-item__nombre" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            (it.variant_title && it.variant_title.indexOf('Default') === -1
              ? '<div class="car-item__variante">' + esc(it.variant_title) + '</div>' : '') +
            bundlePromo +
            '<div class="car-item__precio"><strong>' + money(precioFinal) + '</strong>' +
              (hayDescuento && precioOriginal > precioFinal ? '<s>' + money(precioOriginal) + '</s>' : '') +
            '</div>' + promos +
          '</div>' +
          '<div class="car-item__acciones">' +
            '<div class="drawer-qty">' +
              '<button type="button" data-paso-drawer="-1" data-key="' + esc(it.key) + '" aria-label="Menos">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-paso-drawer="1" data-key="' + esc(it.key) + '" aria-label="Más">+</button>' +
            '</div>' +
            '<button type="button" class="car-item__quitar drawer-quitar" data-quitar-drawer data-key="' + esc(it.key) + '" aria-label="Quitar">✕</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');
    document.getElementById('DrawerItems').innerHTML = html;

    var vacio = document.getElementById('DrawerVacio');
    if (vacio) vacio.hidden = visibles.length > 0;

    // Barra de envío gratis: solo visible si el carrito tiene un bundle con envío gratis
    var envioWrap = document.getElementById('DrawerEnvioWrap');
    var texto = document.getElementById('DrawerEnvioTexto');
    var fill = document.getElementById('DrawerEnvioFill');
    if (envioWrap && texto && fill) {
      var tieneEnvioGratis = cart.items.some(function (it) {
        return it.properties && it.properties._bundle && it.properties._bundle.toLowerCase().indexOf('env') > -1 && it.properties._bundle.toLowerCase().indexOf('gratis') > -1;
      });
      // Also check if quantity >= 3 of main product as fallback
      if (!tieneEnvioGratis) {
        tieneEnvioGratis = cart.items.some(function (it) { return it.quantity >= 3 && it.properties && it.properties._bundle; });
      }
      envioWrap.hidden = !tieneEnvioGratis;
      if (tieneEnvioGratis) {
        texto.innerHTML = '✓ ¡Tenés envío gratis!';
        fill.style.width = '100%';
      }
    }

    // Upsells: ocultar los que ya están en el carrito
    var idsProducto = cart.items.map(function (it) { return String(it.product_id); });
    var sugeridos = drawer.querySelectorAll('[data-upsell]');
    for (var i = 0; i < sugeridos.length; i++) {
      sugeridos[i].hidden = idsProducto.indexOf(sugeridos[i].getAttribute('data-product-id')) > -1;
    }

    // Protección de envío
    var protWrap = document.getElementById('DrawerProteccionWrap');
    var protCheck = document.getElementById('DrawerProteccion');
    if (protWrap && protCheck) {
      protWrap.hidden = visibles.length === 0;
      protCheck.checked = cart.items.some(function (it) { return String(it.variant_id) === PROT; });
    }

    // Totales
    var desc = document.getElementById('DrawerDescuentos');
    if (desc) {
      desc.hidden = !(cart.total_discount > 0);
      if (cart.total_discount > 0) document.getElementById('DrawerDescMonto').textContent = '−' + money(cart.total_discount);
    }
    document.getElementById('DrawerSubtotal').textContent = money(cart.total_price);
    var checkout = document.getElementById('DrawerCheckout');
    if (checkout) checkout.disabled = cart.item_count === 0;

    // Burbuja del header
    var iconos = document.querySelectorAll('.encabezado__carrito');
    for (var j = 0; j < iconos.length; j++) {
      var burbuja = iconos[j].querySelector('.encabezado__burbuja');
      if (cart.item_count > 0) {
        if (!burbuja) {
          burbuja = document.createElement('span');
          burbuja.className = 'encabezado__burbuja';
          iconos[j].appendChild(burbuja);
        }
        burbuja.textContent = cart.item_count;
      } else if (burbuja) {
        burbuja.remove();
      }
    }
  }

  function refrescar(abrirDespues) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        pintar(cart);
        if (abrirDespues) abrir();
        return cart;
      });
  }

  function cambiar(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(pintar);
  }

  function agregar(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) { alert(res.description || 'No se pudo agregar al carrito'); return null; }
      return refrescar(true);
    });
  }

  // Clicks dentro del drawer (steppers, quitar, upsells, cerrar)
  drawer.addEventListener('click', function (e) {
    var paso = e.target.closest('[data-paso-drawer]');
    if (paso) {
      var items = ultimoCarrito ? ultimoCarrito.items : [];
      for (var i = 0; i < items.length; i++) {
        if (items[i].key === paso.getAttribute('data-key')) {
          cambiar(items[i].key, Math.max(0, items[i].quantity + parseInt(paso.getAttribute('data-paso-drawer'), 10)));
          break;
        }
      }
      return;
    }
    var quitar = e.target.closest('[data-quitar-drawer]');
    if (quitar) { cambiar(quitar.getAttribute('data-key'), 0); return; }
    var up = e.target.closest('[data-agregar-upsell]');
    if (up) {
      up.disabled = true;
      agregar(up.getAttribute('data-variant'), 1).then(function () { up.disabled = false; });
      return;
    }
    if (e.target.closest('[data-cerrar-drawer]')) cerrar();
  });

  overlay.addEventListener('click', cerrar);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

  // Protección de envío (checkbox)
  var protCheck = document.getElementById('DrawerProteccion');
  if (protCheck && PROT) {
    protCheck.addEventListener('change', function () {
      if (protCheck.checked) {
        agregar(PROT, 1);
      } else {
        var updates = {};
        updates[PROT] = 0;
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
          .then(function (r) { return r.json(); }).then(pintar);
      }
    });
  }

  // El ícono del carrito abre el drawer
  var aperturas = document.querySelectorAll('.encabezado__carrito, [data-abrir-drawer]');
  for (var k = 0; k < aperturas.length; k++) {
    aperturas[k].addEventListener('click', function (e) {
      e.preventDefault();
      refrescar(true);
    });
  }

  // Todo formulario que agregue al carrito pasa a AJAX + drawer
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1 || form.hasAttribute('data-sin-drawer')) return;
    if (document.getElementById('FormCarrito')) return; // en la página /cart, comportamiento normal
    e.preventDefault();
    var boton = form.querySelector('[type="submit"]');
    if (boton) boton.classList.add('u-btn--cargando');

    // Get selected offer info
    var sel = form.querySelector('.ofertas input[type="radio"]:checked');
    var variantId = sel ? sel.value : form.querySelector('input[name="id"]').value;
    var cantidad = sel ? parseInt(sel.getAttribute('data-cantidad') || '1', 10) : 1;
    var ofertaTitulo = '';
    if (sel) {
      var ofertaEl = sel.closest('.oferta');
      var strong = ofertaEl ? ofertaEl.querySelector('.oferta__info strong') : null;
      if (strong) ofertaTitulo = strong.textContent.trim();
    }

    // Build items array: main product
    var items = [{ id: parseInt(variantId, 10), quantity: cantidad, properties: ofertaTitulo ? { '_bundle': ofertaTitulo } : {} }];

    // Upsell (separate product)
    var upsellCheck = document.getElementById('UpsellCheck');
    if (upsellCheck && upsellCheck.checked) {
      var upsellVarId = upsellCheck.getAttribute('data-variant');
      if (upsellVarId) items.push({ id: parseInt(upsellVarId, 10), quantity: 1 });
    }

    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) { alert(res.description || 'No se pudo agregar al carrito'); return null; }
        return refrescar(true);
      })
      .catch(function () {
        form.setAttribute('data-sin-drawer', '');
        form.submit();
      })
      .then(function () { if (boton) boton.classList.remove('u-btn--cargando'); });
  });

  // Estado inicial (burbuja + contenido)
  refrescar(false);
})();
